import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${API_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const publicAPI = {
  getContent: () => axios.get(`${API}/public/content`),
  getSEO: () => axios.get(`${API}/public/seo`),
  getLegal: (type) => axios.get(`${API}/public/legal/${type}`),
  getMedia: () => axios.get(`${API}/public/media`),
  getSettings: () => axios.get(`${API}/public/settings`),
  getVersion: () => axios.get(`${API}/public/version`),
  getActiveHero: () => axios.get(`${API}/public/hero-active`),
};

export const authAPI = {
  login: (data) => axios.post(`${API}/auth/login`, data),
  forgotPassword: (data) => axios.post(`${API}/auth/forgot-password`, data),
  resetPassword: (data) => axios.post(`${API}/auth/reset-password`, data),
  me: () => axios.get(`${API}/auth/me`, { headers: getAuthHeaders() }),
};

export const adminAPI = {
  getContent: () => axios.get(`${API}/admin/content`, { headers: getAuthHeaders() }),
  updateContent: (fields) => axios.put(`${API}/admin/content`, { fields }, { headers: getAuthHeaders() }),
  getSettings: () => axios.get(`${API}/admin/settings`, { headers: getAuthHeaders() }),
  updateSettings: (data) => axios.put(`${API}/admin/settings`, data, { headers: getAuthHeaders() }),
  getSEO: () => axios.get(`${API}/admin/seo`, { headers: getAuthHeaders() }),
  updateSEO: (data) => axios.put(`${API}/admin/seo`, data, { headers: getAuthHeaders() }),
  getAllLegal: () => axios.get(`${API}/admin/legal`, { headers: getAuthHeaders() }),
  getLegal: (type) => axios.get(`${API}/admin/legal/${type}`, { headers: getAuthHeaders() }),
  updateLegal: (type, content) => axios.put(`${API}/admin/legal/${type}`, { content }, { headers: getAuthHeaders() }),
  getMedia: () => axios.get(`${API}/admin/media`, { headers: getAuthHeaders() }),
  uploadMedia: (formData) => axios.post(`${API}/admin/media`, formData, {
    headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
  }),
  deleteMedia: (id) => axios.delete(`${API}/admin/media/${id}`, { headers: getAuthHeaders() }),
  toggleMedia: (id) => axios.patch(`${API}/admin/media/${id}/toggle`, {}, { headers: getAuthHeaders() }),
  getUsers: () => axios.get(`${API}/admin/users`, { headers: getAuthHeaders() }),
  createUser: (data) => axios.post(`${API}/admin/users`, data, { headers: getAuthHeaders() }),
  updateUser: (id, data) => axios.put(`${API}/admin/users/${id}`, data, { headers: getAuthHeaders() }),
  changePassword: (id, password) => axios.put(`${API}/admin/users/${id}/password`, { new_password: password }, { headers: getAuthHeaders() }),
  deleteUser: (id) => axios.delete(`${API}/admin/users/${id}`, { headers: getAuthHeaders() }),
  getStatistics: () => axios.get(`${API}/admin/statistics`, { headers: getAuthHeaders() }),
  getQRCode: () => axios.get(`${API}/admin/qrcode`, { headers: getAuthHeaders() }),
  getResetTokens: () => axios.get(`${API}/admin/reset-tokens`, { headers: getAuthHeaders() }),
  getVersion: () => axios.get(`${API}/admin/version`, { headers: getAuthHeaders() }),
  downloadBackup: (format) => axios.get(`${API}/admin/backup/${format}`, { headers: getAuthHeaders(), responseType: 'blob' }),
  getHeroCombinations: () => axios.get(`${API}/admin/hero-combinations`, { headers: getAuthHeaders() }),
  createHeroCombination: (data) => axios.post(`${API}/admin/hero-combinations`, data, { headers: getAuthHeaders() }),
  updateHeroCombination: (id, data) => axios.put(`${API}/admin/hero-combinations/${id}`, data, { headers: getAuthHeaders() }),
  activateHeroCombination: (id) => axios.put(`${API}/admin/hero-combinations/${id}/activate`, {}, { headers: getAuthHeaders() }),
  archiveHeroCombination: (id) => axios.put(`${API}/admin/hero-combinations/${id}/archive`, {}, { headers: getAuthHeaders() }),
  reactivateHeroCombination: (id) => axios.put(`${API}/admin/hero-combinations/${id}/reactivate`, {}, { headers: getAuthHeaders() }),
  deleteHeroCombination: (id) => axios.delete(`${API}/admin/hero-combinations/${id}`, { headers: getAuthHeaders() }),
  uploadHeroImage: (id, formData) => axios.post(`${API}/admin/hero-combinations/${id}/upload-image`, formData, {
    headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
  }),
  getHeroMode: () => axios.get(`${API}/admin/hero-mode`, { headers: getAuthHeaders() }),
  setHeroMode: (mode) => axios.put(`${API}/admin/hero-mode`, { hero_mode: mode }, { headers: getAuthHeaders() }),
};

export const trackingAPI = {
  trackClick: (data) => axios.post(`${API}/tracking/click`, data),
  trackQRScan: (data) => axios.post(`${API}/tracking/qr-scan`, data),
};

export const getMediaFileUrl = (mediaId) => `${API}/public/media/${mediaId}/file`;
export const getMediaBySlugUrl = (slug) => `${API}/public/media/slug/${slug}/file`;
export const getQRCodeImageUrl = () => `${API}/public/qrcode/image`;
